import React from 'react';
import {Button, Row, Col, Icon} from 'antd';
import { WeaDialog, WeaSearchGroup, WeaInput, WeaFormItem, WeaCheckbox, WeaTable, WeaError, WeaSelect } from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import {WeaMaterialLib} from 'weaPortalPublic';
import Content_video_prew from './Content_video_prew';
// 多图元素详细设置
class Content_video_detailedSetting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true,
            showTitle: props.showTitle,
            fontSize: props.fontSize,
            titles: <div style={{display: '-webkit-box', position: 'absolute'}}>{getLabel(508352, '视频设置')}<span style={{whiteSpace: 'nowrap', fontSize: '12px', color: 'rgb(153, 153, 153)', display: 'table', position: 'absolute',
                top: '0', left: '70px'}}>{getLabel(501054, '视频元素目前只支持Ogg、MPEG4、WebM三种格式')}</span></div>,
            datas: props.datas,
            selectedDatas: {},
            selectedRowKeys: [],
        };
        this.getButtons = this.getButtons.bind(this);
        this.onOk = this.onOk.bind(this);
        this.getUuid = this.getUuid.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onChangeBgImage = this.onChangeBgImage.bind(this);
        this.getColumns = this.getColumns.bind(this);
        this.getItems = this.getItems.bind(this);
        this.onDeleteTabs = this.onDeleteTabs.bind(this);
        this.deleteTabs = this.deleteTabs.bind(this);
        this.onAddTabs = this.onAddTabs.bind(this);
    }
    onRowSelect(sRowKeys, rows, dataIndex, selectedDatas){
        const newState = {};
        newState.selectedRowKeys = sRowKeys;
        if (selectedDatas) {
            newState.selectedDatas = selectedDatas;
        }
        Object.keys(newState).length > 0 && this.setState(newState);
    }
    getUuid() {
        let s = [];
        let hexDigits = "0123456789abcdef";
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";

        let uuid = s.join("");
        return uuid;
    }
    onChangeBgImage(index,value){
        if(value){
            const { datas={} } = this.state;
            let _datas = [...datas];
            let _value = value.split(",")
            if("multiCheck" == index){
                for (var i = 0; i < _value.length; i++) {
                    _datas.push({ key: this.getUuid(),videoUrl:_value[i], title:'', addType: '1' });
                }

            }else{
                _datas[index].videoUrl = value;
            }
            const __datas = _datas.map((item, index) => {
                return {...item, key: index}
            })
            this.setState({
                datas: __datas
            });
        }
    }
    getColumns(){
        const { datas= {}, fontSize, showTitle } = this.state;
        let _datas = [...datas];
        const options = [{key: "1", selected: true, showname: "选择文件"},{key: "2", showname: "URL路径"}];
        const columns= [
            {
                title: '视频来源',
                display: 'true',
                width: '33%',
                className: 'wea-table-edit-upload',
                render: (text, record, index) => {
                        return (
                            <div className="e9login-bg-images-btns-materiallib">
                                <WeaSelect style={{width: '60%', paddingBottom: '30px'}} options={options} value={record.addType} onChange={(value)=>{
                                    _datas[record.key].addType = value;
                                    this.setState({datas: _datas});
                                }}/>
                                {
                                    record.addType == '1' ? <WeaMaterialLib value={record.videoUrl} onChange={(value)=>this.onChangeBgImage(record.key,value)}/> :
                                        <WeaInput value={record.videoUrl} onChange={(value)=>this.onChangeBgImage(record.key,value)}/>
                                }
                            </div>
                        )
                },
            },{
                title: '视频预览',
                display: 'true',
                key: 'img',
                width: '33%',
                className: 'wea-table-edit-prew',
                render: (text, record, index) => (
                    <Content_video_prew title={record.title} imgSrc={record.videoUrl} fontSize={fontSize} showTitle={showTitle}/>
                )
            },
            {
                title: '视频标题',
                display: 'true',
                width: '33%',
                key: 'title',
                className: 'wea-table-edit-title',
                render: (text, record, index) => (
                    <WeaError
                        //tipPosition='bottom'
                        ref={el => {this[`weaError_${index}`] = el}}
                        error='数据为空'>
                        <WeaInput
                            value={record.title || ''}
                            viewAttr={showTitle== '1'? 3 : 2}
                            onChange={(value)=>{
                                _datas[record.key].title = value;
                                this.setState({datas: _datas});
                            }}/>
                    </WeaError>
                )
            }
        ]
        return columns;
    }
    getItems(){
        const { showTitle, fontSize } = this.state;
        const items= [
            {com:<WeaFormItem 
                label={getLabel(386587, '显示标题栏')}
                labelCol={{span: 8}} 
                wrapperCol={{span: 14}}>
                    <WeaCheckbox
                        value={showTitle}
                        display="switch"
                        id='test'
                        style={{display: 'inline'}}
                        onChange={(value)=>this.setState({showTitle: value})}
                    />
                </WeaFormItem>},
            {com:<WeaFormItem
                label={getLabel(386588, '标题文字大小')}
                labelCol={{span: 8}}
                wrapperCol={{span: 14}}
            >
            <div style={{display: 'inline-block'}}>
                <WeaInput value={fontSize} onChange={(value)=>this.setState({fontSize: value})} style={{width: '82px', display: 'inline-block'}}/>
                <div style={{display: 'inline-block', marginLeft: '10px'}}>px</div>
            </div>
            </WeaFormItem>}
        ]
        return items;
    }
    onDeleteTabs() {
        const { selectedRowKeys, datas} = this.state;
        for (let i = 0; i < selectedRowKeys.length; i++) {
            this.deleteTabs(selectedRowKeys[i]);
        }
        this.setState({
            selectedRowKeys: []
        });
    }

    onAddTabs(){
        const { datas={} } = this.state;
        let _datas = [...datas];
        _datas.push({ key: _datas.length,videoUrl: '', title:'', addType: '2' });
        this.setState({
            datas: _datas
        });
    }

    deleteTabs(dataId){
        const { datas, selectedRowKeys } = this.state;
        for (let i = 0; i< datas.length; i++) {
            if (datas[i].key == dataId) {
                datas.splice(i, 1);
                break;
            }
        }
        this.setState({
            datas:datas,
            selectedRowKeys: []
        });
    }
    render() {
        const {visible, eFieldNewDataSource, eFieldNewUsedKeys, searchName, title, items, isModalEdit, datas, titles, selectedDatas, selectedRowKeys } = this.state;
        // 记录选中的行
        const _self = this;
        const rowSelection = {
            onChange(selectedRowKeys) {
                _self.setState({selectedRowKeys: selectedRowKeys})
            }
        };
        console.log("-------datas :", datas)
        return (
            <WeaDialog
                visible={visible}
                title={getLabel(19342, '详细设置')}
                icon="icon-coms-portal"
                iconBgcolor='#1a57a0'
                style={{width: 792, height: 490}}
                buttons={this.getButtons()}
                onCancel={this.onCancel}
                hasScroll={true}
            >
                <WeaSearchGroup showGroup={true} title={getLabel(386589, '标题栏设置')} items={this.getItems()} col={1}/>
                <WeaSearchGroup title={titles} needTigger={true} showGroup={true} customComponent={
                    <div style={{display: 'inline-block'}}>
                        <div style={{display: 'inline-block'}} title={getLabel(125333, '选择文件')}>
                            <WeaMaterialLib multiCheck={true} onChange={(value)=>this.onChangeBgImage("multiCheck",value)} type='button'>
                                <Button type="primary" style={{borderRadius: 0, padding: '0 4px'}}>
                                    <Icon type="search" style={{color: '#fff'}}/>
                                </Button>
                            </WeaMaterialLib>
                        </div>
                        <Button type="primary" style={{borderRadius: 0, margin: '0 10px', padding: '0 4px'}} onClick={this.onAddTabs} title={getLabel(384113, '添加')}>
                            <Icon type="plus" style={{color: '#fff'}}/>
                        </Button>
                        <Button type="primary" disabled={!(selectedRowKeys && selectedRowKeys.length)} title={getLabel(506969, '删除')} style={{borderRadius: 0, padding: '0 4px'}} onClick={this.onDeleteTabs}>
                            <Icon type="minus" style={{color: '#fff'}}/>
                        </Button>
                    </div>
                }>
                    <WeaTable
                        ref='tableEdit'
                        draggable={true}
                        isModalEdit={isModalEdit}
                        dataSource={datas}
                        //title={titles}
                        ref={el => {this.table = el}}
                        rowSelection={rowSelection} 
                        selectedData={selectedDatas}
                        selectedRowKeys={selectedRowKeys}
                        columns={this.getColumns()}
                    />
                </WeaSearchGroup>
            </WeaDialog>
        );
    }

    getButtons() {
        let buttons = [];
        buttons.push(<Button type="primary" onClick={this.onOk}>{getLabel(826, '确定')}</Button>);
        buttons.push(<Button type="ghost" onClick={this.onCancel}>{getLabel(31129, '取消')}</Button>);
        return buttons;
    }

    onOk(){
        const { datas, showTitle, fontSize } = this.state;
        let isPass = true;
        if(showTitle == '1'){
            datas.map((item,index) => {
                if(item.title == '') {
                    this[`weaError_${index}`] && this[`weaError_${index}`].showError();
                    isPass = false;
                    return;
                }
            });
        }
        isPass && this.props.onOk(datas, showTitle, fontSize);
    }

    onCancel(){
        this.props.onCancel();
    }
}

export default Content_video_detailedSetting;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_video_detailedSetting.js